<template>
  <div class="sub-routes">
    <section class="app-section"
             id="objectList">

      <el-tabs type="border-card"
               v-model="tabChoosed"
               style="font-size: 14px"
               @tab-click="handleClick">
        <el-tab-pane label="草稿箱"
                     name="0">
          <!-- <el-button type="primary"
                     @click="createNewObject()">
            <i class="el-icon-plus"></i>创建新对象
          </el-button>-->
          <el-table border
                    v-loading="loading"
                    @sort-change="sortChange"
                    :data="tableData"
                    style="width: 100%;font-size: 14px;font-size: 14px"
                    @row-click="toTaskDetail"
                    :default-sort="{ prop: 'date', order: 'descending' }">
            <el-table-column align='center'
                             min-width="80"
                             prop="task_name"
                             label="任务名称"
                             sortable="custom">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'Modifiable')">{{ scope.row.task_name }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="80"
                             prop="start_time"
                             label="开始时间"
                             sortable="custom">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'Modifiable')">{{ scope.row.start_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="80"
                             prop="end_time"
                             label="结束时间">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'Modifiable')">{{ scope.row.end_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="60"
                             prop="end_time"
                             label="推送时间">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'Modifiable')">{{ scope.row.push_time.substr(0, 5)?scope.row.push_time.substr(0, 5):'--' }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="80"
                             prop="created_time"
                             label="创建时间">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'Modifiable')">{{ scope.row.created_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="50"
                             prop="dept_name"
                             label="发起部门">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'Modifiable')">{{ scope.row.dept_name }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="50"
                             prop="task_status"
                             label="任务状态">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'Modifiable')">{{ scope.row.task_status }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             prop="operation"
                             label="操作">
              <template slot-scope="scope">
                <el-button type="text"
                           @click.stop="activation(scope.row)"
                           style="color: #4286f1;"
                           size="medium">开始</el-button>
                <!-- <el-button type="text"
                size="medium">修改</el-button>-->
                <el-button type="text"
                           @click.stop="checkTaskDet(scope.row, 'Modifiable')"
                           size="medium"
                           style="color: #4286f1;">编辑</el-button>
                <el-button type="text"
                           class="delete"
                           @click.stop="deleteType(scope.row, 0)"
                           size="medium">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background
                         @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page.sync="draftPage"
                         :page-sizes="[10]"
                         :total="draftTotal"
                         layout="  total,prev, pager, next"></el-pagination>
          <!-- <el-pagination background
                         layout="prev, pager, next"
          :total="tableDataLen"></el-pagination>-->
        </el-tab-pane>
        <el-tab-pane label="已开始"
                     name="1">
          <el-table border
                    v-loading="loading"
                    :data="tableData"
                    @row-click="toTaskDetail"
                    @sort-change="sortChange"
                    style="width: 100%;font-size: 14px"
                    :default-sort="{ prop: 'date', order: 'descending' }">
            <el-table-column align='center'
                             min-width="80"
                             prop="task_name"
                             label="任务名称"
                             sortable="custom">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, scope.row.task_status)">{{ scope.row.task_name }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="80"
                             prop="start_time"
                             label="开始时间"
                             sortable="custom">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, scope.row.task_status)">{{ scope.row.start_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="80"
                             prop="end_time"
                             label="结束时间">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, scope.row.task_status)">{{ scope.row.end_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="60"
                             prop="end_time"
                             label="推送时间">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'Modifiable')">{{ scope.row.push_time.substr(0, 5)?scope.row.push_time.substr(0, 5):'--' }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="80"
                             prop="created_time"
                             label="创建时间">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, scope.row.task_status)">{{ scope.row.created_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="50"
                             prop="dept_name"
                             label="发起部门">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, scope.row.task_status)">{{ scope.row.dept_name }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="50"
                             label="任务状态">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, scope.row.task_status)"
                     :class="scope.row.task_status === '执行中' ? 'zhixing' : ''">{{ scope.row.task_status }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             prop="operation"
                             label="操作">
              <template slot-scope="scope">
                <!-- <el-button type="text"
                           v-if="scope.row.task_status!='执行中'"
                           @click.stop="cancel(scope.row)"
                size="medium">转为草稿</el-button>-->
                <!-- <el-button type="text"
                size="medium">修改</el-button>-->
                <el-button type="text"
                           v-if="scope.row.task_status != '执行中' "
                           @click.stop="checkTaskDet(scope.row, scope.row.task_status)"
                           size="medium"
                           style="color: #4286f1;">查看</el-button>
                <el-button type="text"
                           v-if="scope.row.task_status == '执行中' "
                           @click.stop="checkTaskDet(scope.row, scope.row.task_status)"
                           size="medium"
                           style="color: #4286f1;">查看</el-button>
                <el-button type="text"
                           class="delete"
                           v-if="scope.row.task_status != '执行中' "
                           @click.stop="deleteType(scope.row, 1)"
                           size="medium">删除</el-button>
                <el-button type="text"
                           v-if="scope.row.task_status == '执行中'"
                           @click.stop="termination(scope.row)"
                           size="medium"
                           style="color: #4286f1;">终止</el-button>
                <el-button type="text"
                           v-if="scope.row.task_status == '执行中'"
                           @click.stop="toSeats(scope.row)"
                           size="medium"
                           style="color: #4286f1;">坐席执行</el-button>
              </template>
              <!-- <el-pagination background
                             layout="prev, pager, next"
              :total="tableDataLen"></el-pagination>-->
            </el-table-column>
          </el-table>
          <el-pagination background
                         @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :total="startedTotal"
                         :page-sizes="[10]"
                         :current-page.sync="startedPage"
                         layout=" total, prev, pager, next"></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="已结束"
                     name="2">
          <el-table border
                    v-loading="loading"
                    @row-click="toTaskDetail"
                    :data="tableData"
                    style="width: 100%;font-size: 14px"
                    @sort-change="sortChange"
                    :default-sort="{ prop: 'date', order: 'descending' }">
            <el-table-column align='center'
                             min-width="80"
                             prop="task_name"
                             label="任务名称"
                             sortable="custom">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'onlyShow')">{{ scope.row.task_name }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="80"
                             prop="start_time"
                             label="开始时间"
                             sortable="custom">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'onlyShow')">{{ scope.row.start_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="80"
                             prop="end_time"
                             label="结束时间">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'onlyShow')">{{ scope.row.end_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="60"
                             prop="end_time"
                             label="推送时间">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'Modifiable')">{{ scope.row.push_time.substr(0, 5)?scope.row.push_time.substr(0, 5):'--' }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="80"
                             prop="created_time"
                             label="创建时间">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'onlyShow')">{{ scope.row.created_time }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="50"
                             prop="dept_name"
                             label="发起部门">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'onlyShow')">{{ scope.row.dept_name }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             min-width="50"
                             prop="task_status"
                             label="任务状态">
              <template slot-scope="scope">
                <div @click="checkTaskDet(scope.row, 'onlyShow')">{{ scope.row.task_status }}</div>
              </template>
            </el-table-column>
            <el-table-column align='center'
                             prop="operation"
                             label="操作">
              <template slot-scope="scope">
                <!-- <el-button type="text"
                           @click.stop="termination(scope.row)"
                           size="medium">停止</el-button>
                <el-button type="text"
                           @click.stop="checkTaskDet(scope.row,'onlyShow')"
                size="medium">修改</el-button>-->
                <el-button type="text"
                           @click.stop="checkTaskDet(scope.row, 'onlyShow')"
                           size="medium"
                           style="color: #4286f1;">查看</el-button>
                <el-button type="text"
                           class="delete"
                           @click.stop="deleteType(scope.row, 3)"
                           size="medium">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background
                         @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page.sync="finishedPage"
                         :page-sizes="[10]"
                         :total="finishedTotal"
                         layout="total,  prev, pager, next"></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </section>

  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { MessageBox, Message } from 'element-ui'
let qs = require('qs')
export default {
  props: {
    creatData: '',
  },
  data() {
    return {
      draftPage: 1,
      draftTotal: 1,
      startedPage: 1,
      startedTotal: 1,
      finishedPage: 1,
      finishedTotal: 1,
      tableData: [],
      num: 0,
      page: 1,
      tableDataLen: 0,
      tabChoosed: '0',
      loading: false,
      sorting: {},
    }
  },

  mounted() {
    this.tableData = this.FollowUpList

    let index = this.$store.state.taskIndex || '0'

    this.num = index
    if (index == 2) {
      this.num = 3
    }
    console.log(366, this.creatData)
    console.log(this.creatData)
    if (this.creatData != undefined) {
      console.log(368, this.creatData)
      this.tabChoosed = this.creatData
      this.getList(this.creatData, 1, 10)
    } else {
      this.getList(0, 1, 10)
    }
    //     if (index == 0) {
    //       this.draftPage = this.$store.state.taskPage || 1
    //       this.getList(this.num, this.draftPage, 10)
    //     } else if (index == 1) {
    //       this.startedPage = this.$store.state.taskPage || 1
    //       this.getList(this.num, this.startedPage, 10)
    //     } else {
    //       console.log(this.$store.state.taskPage)
    //       this.finishedPage =  || 1
    //       console.log(this.$store.state.taskPage)
    //       this.getList(this.num, this.finishedPage, 10)
    //     }
  },
  computed: mapState(['FollowUpList']),
  methods: {
    sortChange(row) {
      if (this.num == 2) {
        this.num = 3
      }
      let pages = 1

      if (this.num == 0) {
        pages = this.draftPage
      } else if (this.num == 1) {
        pages = this.startedPage
      } else {
        pages = this.finishedPage
      }
      if (row.column.property == 'start_time') {
        if (row.order == 'descending') {
          this.getList(this.num, pages, 10, 'startTime', '0')
          this.sorting.status = 'startTime'
          this.sorting.code = '0'
        } else {
          this.getList(this.num, pages, 10, 'startTime', '1')
          this.sorting.status = 'startTime'
          this.sorting.code = '1'
        }
      } else {
        if (row.order == 'descending') {
          this.getList(this.num, pages, 10, 'taskName', '0')
          this.sorting.status = 'taskName'
          this.sorting.code = '0'
        } else {
          this.getList(this.num, pages, 10, 'taskName', '1')
          this.sorting.status = 'taskName'
          this.sorting.code = '1'
        }
      }
    },

    handleSizeChange() {
      console.log(1)
    },
    toSeats(row) {
      let obj = {
        follow_person_code: row.task_code,
        questionnaire_code: row.questionnaire_code,
        task_code: row.task_code,
      }
      console.log(obj)
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'operate',
        title: '坐席执行',
        key: `operate?${obj.task_code}`,
        extra: {
          taskData: obj,
        },
      })
    },
    handleCurrentChange(val) {
      let flag = JSON.stringify(this.sorting) == '{}'
      console.log(flag)
      //
      if (this.num == 2) {
        this.num = 3
      }
      if (this.num == 0) {
      } else if (this.num == 1) {
      } else {
      }
      if (flag) {
        this.getList(this.num, val, 10)
      } else {
        this.getList(this.num, val, 10, this.sorting.status, this.sorting.code)
      }
    },
    operationtip(res) {
      //       console.log(res, this.num)
      if (res.code == 0) {
        if (this.num == 0) {
          this.getList(this.num, this.draftPage, 10)
        } else if (this.num == 1) {
          this.getList(this.num, this.startedPage, 10)
        } else {
          this.getList(3, this.finishedPage, 10)
        }
        Message({
          type: 'success',
          message: '操作成功',
        })
      } else {
        Message({
          message: res.data.message,
        })
      }
    },

    operationtips(res) {
      console.log(res, this.num)
      if (res.data.code == 0) {
        if (this.num == 0) {
          this.getList(this.num, this.draftPage, 10)
        } else if (this.num == 1) {
          this.getList(this.num, this.startedPage, 10)
        } else {
          this.getList(3, this.finishedPage, 10)
        }
        Message({
          type: 'success',
          message: '操作成功',
        })
      } else {
        Message({
          message: res.data.message,
        })
      }
    },
    cancel(row) {
      MessageBox.confirm('是移至草稿箱?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        let query = {
          task_code: row.task_code,
        }
        this.$utils
          .caringRequest({
            method: 'PUT',
            url:
              this.$utils.getInterface('TO_DRAFT') + '?' + qs.stringify(query),
          })
          .then((res) => {
            console.log(res)
            this.operationtips(res)
          })
      })
    },
    activation(row) {
      MessageBox.confirm('是否确认开始?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        let query = {
          task_code: row.task_code,
        }
        this.$utils.caringRequest({
          method: 'PUT',
          url: this.$utils.getInterface('TO_START') + '?' + qs.stringify(query),
          success: (res) => {
            console.log('开始', res)
            if (res.code == 0) {
              this.operationtip(res)
            } else {
              Message({
                type: 'warning',
                message: res.message,
              })
            }

            //     this.operationtips(res)
          },
        })
        //   .then((res) => {
        //     console.log(res)

        //   })
      })
    },
    termination(row) {
      MessageBox.confirm('是否确认停止?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        let query = {
          task_code: row.task_code,
        }
        this.$utils.caringRequest({
          method: 'PUT',
          url:
            this.$utils.getInterface('TO_NOT_FINISHED') +
            '?' +
            qs.stringify(query),
          success: (res) => {
            if (res.data.code == 0) {
              this.operationtips(res)
            } else {
              Message({
                type: 'warning',
                message: res.message,
              })
            }
          },
        })
      })
    },
    checkTaskDet(row, status) {
      console.log(row.person_status, status)
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'editTask',
        title: row.task_name,
        key: `editTask?${row.task_code}`,
        extra: {
          follwData: row,
        },
      })
      if (status == 'onlyShow' || status == '执行中') {
        // this.bus.$emit('showInfro', obj)
      } else {
        this.$store.commit('setAllSelectedKeys', {
          type: 'add',
          name: 'editTask',
          title: row.task_name,
          key: `editTask?${row.task_code}`,
          extra: {
            follwData: row,
          },
        })
      }
    },
    toTaskDetail(row) {
      //creatTask
      // if (row.task_status == '未完成' || row.task_status == '已完成') {
      //   this.$router.push({
      //     path: '/homeIndex/showInfro',
      //     query: {
      //       code: row.task_code,
      //       task_code: this.num
      //     }
      //   })
      // } else if (row.task_status == '草稿' || row.task_status == '未开始') {
      //   this.$router.push({
      //     path: '/homeIndex/checkTask',
      //     query: {
      //       code: row.task_code,
      //       task_code: this.num
      //     }
      //   })
      // }
    },
    handleClick(tab, event) {
      this.sorting = {}

      this.startedPage = 1
      this.draftPage = 1
      this.finishedPage = 1
      this.tableData = []
      this.num = tab.index * 1

      if (tab.index == 2) {
        this.getList(3, 1, 10)
      } else {
        this.getList(tab.index, 1, 10)
      }
    },

    changeState(resData) {
      resData.forEach((val, ind) => {
        val.start_time = val.start_time.substring(0, 10)
        val.end_time = val.end_time.substring(0, 10)
        if (val.task_status == 0) {
          val.task_status = '草稿'
        }
        if (val.task_status == 1) {
          val.task_status = '执行中'
        }
        if (val.task_status == 2) {
          val.task_status = '执行中'
        }
        if (val.task_status == 3) {
          val.task_status = '已完成'
        }
        if (val.task_status == 4) {
          val.task_status = '未完成'
        }
      })
      return resData
    },

    getList(num, page, size, taskName, order_type) {
      //       if (!this.tableData.length) {
      //         this.loading = true
      //       }
      this.loading = true
      let query = {
        task_status: num,
        size: size,
        page: page,
      }
      if (taskName) {
        query.order_name = taskName
        query.order_type = order_type
      }

      this.$utils.caringRequest({
        method: 'get',
        url: this.$utils.getInterface('TASK_LIST') + '?' + qs.stringify(query),
        success: (res) => {
          this.loading = false
          this.tableData = this.changeState(res.data.records)
          //   console.log
          //   this.draftPage = this.$store.state.taskPage || 1

          if (num == 0) {
            this.draftTotal = res.data.total
            this.draftPage = res.data.current
          } else if (num == 1) {
            this.startedTotal = res.data.total
            this.startedPage = res.data.current
          } else {
            this.finishedTotal = res.data.total

            this.finishedPage = res.data.current
          }
        },
      })
    },
    formatter(row, column) {
      return row.address
    },
    createNewObject() {
      this.$router.push({
        path: '/homeIndex/creatTask',
      })
    },
    deleteType(val, num) {
      console.log(val)
      MessageBox.confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        let query = {
          task_code: val.task_code,
        }
        this.$utils.caringRequest({
          method: 'DELETE',
          url:
            this.$utils.getInterface('DELETE_TASK_INFO') +
            '?' +
            qs.stringify(query),
          success: (res) => {
            if (res.data.code == 0) {
              this.operationtips(res)
            } else {
              Message({
                type: 'warning',
                message: res.message,
              })
            }
          },
        })
        //   .then((res) => {
        //     console.log(res)
        //     if (res.data.code == 0) {
        //       if (num == 0) {
        //         this.getList(num, this.draftPage, 10)
        //       } else if (num == 1) {
        //         this.getList(num, this.startedPage, 10)
        //       } else {
        //         this.getList(3, this.finishedPage, 10)
        //       }

        //       Message({
        //         type: 'success',
        //         message: '删除成功',
        //       })
        //     }
        //   })

        //   Message({
        //     type: 'success',
        //     message: '删除成功!'
        //   })
      })
    },
  },
  beforeDestroy() {
    //     this.bus.$off('permission')
  },
}
</script>
<style scoped  lang="less">
// @import '../../assets/common.scss';
.delete {
  color: #fa7070;
}
#objectList {
  background-color: #f8f8f8;
  // padding: 20px;
  .el-table {
    margin-top: 15px;
  }
  .el-pagination {
    text-align: right;
    margin: 20px 0;
  }
}
.zhixing {
  color: #fa7070;
}
</style>
